import { useState, useEffect } from 'react';

// Custom hook to manage version tracking and notification display
export const useNewVersion = (currentVersion = '1.0.0') => {
    const [showNewVersionScreen, setShowNewVersionScreen] = useState(false);

    useEffect(() => {
        const storedVersion = localStorage.getItem('appVersion');

        let timer: NodeJS.Timeout;

        if (storedVersion !== currentVersion) {
            setShowNewVersionScreen(true);
            localStorage.setItem('appVersion', currentVersion);

            // Auto-hide the notification after 3 seconds
            timer = setTimeout(() => {
                setShowNewVersionScreen(false);
            }, 3000);
        }

        // Always return a cleanup function, even if no timer was set
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [currentVersion]);

    return showNewVersionScreen;
};
